import { render, staticRenderFns } from "./WorkSpace.vue?vue&type=template&id=ac0ae00e&scoped=true&"
import script from "./WorkSpace.vue?vue&type=script&lang=js&"
export * from "./WorkSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0ae00e",
  null
  
)

export default component.exports